import { BenefitList, Eyebrow } from "@/components/landing/shared";

interface StoreCustomizerIntroProps {
	eyebrow: string;
	title: string;
	subtitle: string;
	benefits: string[];
}

function StoreCustomizerIntro(prop: StoreCustomizerIntroProps) {
	const { eyebrow, title, subtitle, benefits } = prop;
	return (
		<div>
			<Eyebrow>{eyebrow}</Eyebrow>
			<h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">{title}</h2>
			<p className="mt-4 max-w-md text-lg leading-relaxed text-muted-foreground">{subtitle}</p>
			<div className="mt-8">
				<BenefitList items={benefits} />
			</div>
		</div>
	);
}

export default StoreCustomizerIntro;
